/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SetupPayment/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ActiveStep from './ActiveStep/index'
import Breakdown from './Breakdown/index'
import Payers from './Payers/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SetupPayment({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<Payers
  viewPath={`${viewPath}/Payers`}
/>
<div
  data-testid="SetupPayment.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="SetupPayment.Vertical"
  data-view-path={viewPath}
 style={{'--brc-1-1JT6jL': dtColorsNeutral200,'--bc-2-1JT6jL': dtColorsNeutral100,'--pt-3-1JT6jL': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-4-1JT6jL': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-5-1JT6jL': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<ActiveStep
  viewPath={`${viewPath}/ActiveStep`}
/>
</div>
<div
  data-testid="SetupPayment.Vertical:1"
  data-view-path={viewPath}
 style={{'--pb-6-1JT6jL': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pt-3-1JT6jL': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pr-5-1JT6jL': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--pl-4-1JT6jL': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical1}`}
>
<Breakdown
  viewPath={`${viewPath}/Breakdown`}
/>
</div>
</div>
{children}
</React.Fragment>)
}